import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface customReportsPropsState {
    [key: string]: string[];
}

const initialState: customReportsPropsState = {
    leadStates: [],
    leadSources: [],
    leadStages: [],
    leadStatuses: [],
    leadAdmissionStatuses: [],
    leadWelcomeCallByAdmissionTeamStatuses: [],
    leadVisaProcessingStatuses: [],
    leadApplicationMovedStatuses: [],
    leadConditionalOfferLetterStatuses: [],
    leadUnConditionalOfferLetterStatuses: [],
    leadFeePaymentStatuses: [],
    leadFileSubmissionStatuses: [],
    leadFollowUpStatuses: [],
    leadAssigneeOptions: [],
    leadCampaignOptions: [],
    leadPrefferedStreams: [],
    leadDestinations: [],
    nameSearchString: [],
    phoneSearchString: [],
    createdAtStartDate: [],
    createdAtEndDate: [],
    leadSubAgentOptions: [],
    updatedAtStartDate: [],
    updatedAtEndDate: [],
    leadIntakeMonth: [],
    leadIntakeYear: []
};

const customReportsPropsSlice = createSlice({
    name: 'customReportsProps',
    initialState,
    reducers: {
        setLeadProperty: (state, action: PayloadAction<{ key: string; value: string[] }>) => {
            if (state.hasOwnProperty(action.payload.key)) {
                state[action.payload.key] = action.payload.value;
            }
        },

        setSearchString: (state, action: PayloadAction<{ key: string; value: string[] }>) => {
            if (state.hasOwnProperty(action.payload.key)) {
                state[action.payload.key] = action.payload.value;
            }
        },
        
        setDateFilters: (state, action: PayloadAction<{ startDate?: string[]; endDate?: string[] }>) => {
            if (action.payload.startDate !== undefined) {
                state.createdAtStartDate = action.payload.startDate;
            }
            if (action.payload.endDate !== undefined) {
                state.createdAtEndDate = action.payload.endDate;
            }
        },

        // clear all lead management props
        clearCustomReportsProps: () => initialState,

        // clear lead management props other than the nameSearchString and phoneSearchString
        clearCustomReportsFilterProps: (state) => {
            state.leadStates = [];
            state.leadSources = [];
            state.leadStages = [];
            state.leadStatuses = [];
            state.leadAdmissionStatuses = [];
            state.leadWelcomeCallByAdmissionTeamStatuses = [];
            state.leadVisaProcessingStatuses = [];
            state.leadApplicationMovedStatuses = [];
            state.leadConditionalOfferLetterStatuses = [];
            state.leadUnConditionalOfferLetterStatuses = [];
            state.leadFeePaymentStatuses = [];
            state.leadFileSubmissionStatuses = [];
            state.leadFollowUpStatuses = [];
            state.leadAssigneeOptions = [];
            state.leadCampaignOptions = [];
            state.leadPrefferedStreams = [];
            state.leadDestinations = [];
            state.createdAtStartDate = [];
            state.createdAtEndDate = [];
            state.leadSubAgentOptions = [];
            state.updatedAtStartDate = [];
            state.updatedAtEndDate = [];
            state.leadIntakeMonth = [];
            state.leadIntakeYear = [];
        },

        // clear lead management props nameSearchString and phoneSearchString
        clearCustomReportsPropsSearchString: (state) => {
            state.nameSearchString = [];
            state.phoneSearchString = [];
        },

        clearCustomReportsAssigneeOptions: (state) => {
            state.leadAssigneeOptions = [];
        }
    }
});

export const { setLeadProperty,
    setSearchString,
    setDateFilters,
    clearCustomReportsProps,
    clearCustomReportsFilterProps,
    clearCustomReportsPropsSearchString,
    clearCustomReportsAssigneeOptions } = customReportsPropsSlice.actions;
export default customReportsPropsSlice.reducer;
